import React from "react";

const NoDataFound: React.FC = () => {
  return (
    <div className="no-data-found">
      <h4>No Data Found</h4>
    </div>
  );
};

export default NoDataFound;
